import type { Board, Cell, Coord, TileType } from './types.js';

export const inBounds = (board: Board, c: Coord): boolean =>
  c.x >= 0 && c.y >= 0 && c.x < board.size && c.y < board.size;

export const cellAt = (board: Board, c: Coord): Cell => {
  if (!inBounds(board, c)) {
    throw new Error(`cellAt: ${c.x},${c.y} out of bounds (size=${board.size})`);
  }
  return board.cells[c.y]![c.x] as Cell;
};

export const tileAt = (board: Board, c: Coord): TileType => cellAt(board, c).tile;

export const setCell = (
  cells: readonly (readonly Cell[])[],
  c: Coord,
  next: Cell,
): readonly (readonly Cell[])[] => {
  const out = cells.map((row) => [...row]);
  out[c.y]![c.x] = next;
  return out;
};

export const replaceCells = (
  cells: readonly (readonly Cell[])[],
  updates: ReadonlyMap<string, Cell>,
): readonly (readonly Cell[])[] => {
  const out = cells.map((row) => [...row]);
  updates.forEach((cell, key) => {
    const [xs, ys] = key.split(',');
    const x = Number(xs);
    const y = Number(ys);
    out[y]![x] = cell;
  });
  return out;
};

export const allCoords = (board: Board): Coord[] => {
  const out: Coord[] = [];
  for (let y = 0; y < board.size; y++) {
    for (let x = 0; x < board.size; x++) out.push({ x, y });
  }
  return out;
};
